// extracted by mini-css-extract-plugin
export default {"desktop":"desktop__-TJIF","burger":"burger__Yrb6g","light":"light__5lMr1","dark":"dark__ISvd5"};